import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";

const variants = {
  onscreen: {
    transition: { staggerChildren: 0.15 }
  }
};

const childerVariants = {
  offscreen: {
    y: 50,
    opacity: 0
  },
  onscreen: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 }
    }
  },
};

const BenefitText = ({ 
  number, 
  title,
  text,
  bulletList
}) => {
  return(
    <motion.div variants={variants} className="timeline-text">
      <motion.span className="benefit-number" variants={childerVariants}>{number}</motion.span>
      <motion.h3 variants={childerVariants}>{title}</motion.h3>
      <motion.p variants={childerVariants}>{text}</motion.p>
      { bulletList && bulletList.length > 0 &&
        <motion.ul variants={childerVariants}>
          {bulletList.map(b => <li><strong style={{ fontWeight: 600 }}>{b.bold}</strong>{b.text}</li>)}
        </motion.ul>
      }
    </motion.div>
  );
};

export default BenefitText;